import React from "react";
import UserPopupArrow from "@assets/icons/userPopupArrow";
import { useIsOn } from "src/hooks/useFeatureToggle";
import { FEATURE_TOGGLES } from "src/lib/featureToggles";

export interface ProductItem {
  label: string;
  icon: React.ReactNode;
}

export const useProductItems = (): ProductItem[] => {
  const isMyProductsEnabled = useIsOn(FEATURE_TOGGLES.MY_PRODUCTS);
  const isCROModuleEnabled = useIsOn(FEATURE_TOGGLES.CRO_MODULE);
  const isAdCampaignEnabled = useIsOn(FEATURE_TOGGLES.AD_CAMPAIGN_MANAGER);
  const isSubscriptionPerformanceEnabled = useIsOn(
    FEATURE_TOGGLES.SUBSCRIPTION_PERFORMANCE,
  );

  const productItems: ProductItem[] = [];

  if (isMyProductsEnabled) {
    productItems.push({
      label: "My Products",
      icon: <UserPopupArrow />,
    });
  }

  if (isCROModuleEnabled) {
    productItems.push({
      label: "CRO Module",
      icon: <UserPopupArrow />,
    });
  }

  if (isAdCampaignEnabled) {
    productItems.push({
      label: "Ad Campaign Manager",
      icon: <UserPopupArrow />,
    });
  }

  if (isSubscriptionPerformanceEnabled) {
    productItems.push({
      label: "Subscription Performance",
      icon: <UserPopupArrow />,
    });
  }

  return productItems;
};
